import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  snackBarRef: MatSnackBarRef<any>;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(private _snackBar: MatSnackBar) {}

  private _show(message: string, panelClass: string, duration = 3000) {
    const config: MatSnackBarConfig = {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration,
      panelClass,
    };
    this.snackBarRef = this._snackBar.open(message, '', config);
  }

  error(message: string) {
    this._show(message, 'snackbar-error', 4000);
  }

  success(message: string) {
    this._show(message, 'snackbar-success', 3000);
  }

  info(message: string) {
    this._show(message, 'snackbar-info', 3000);
  }

  warning(message: string) {
    this._show(message, 'snackbar-warning', 3500);
  }

  /** Convenience alias matching unifi-capitals pattern */
  show(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
    switch (type) {
      case 'success': this.success(message); break;
      case 'error':   this.error(message);   break;
      case 'warning': this.warning(message); break;
      default:        this.info(message);    break;
    }
  }
}
